import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../components/admin/Header';
import SideBar from '../../components/admin/SideBar';
import { GiCheckMark } from 'react-icons/gi';
import { CgCloseO } from 'react-icons/cg';
import { FaEnvelope } from 'react-icons/fa';
import { MdLocalPhone } from 'react-icons/md';

const Subscription = () => {
  const navigate = useNavigate()

  const [toggleNav, setToggleNav] = useState(false)

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    document.title = "Island Luxury - Plans"
		if(!userInfo) {
			navigate("/")
		}
	}, [userInfo, navigate])

  const pricing = [
    {
      tier: "Basic",
      price: "1000",
      benefits: [
        {
          text: "1 Listings(Max)",
          status: "yes"
        },
        {
          text: "Premium Listings",
          status: "no"
        },
        {
          text: "Unlimited Property Requests",
          status: "yes"
        }
      ]
    },
    {
      tier: "Bronze",
      price: "3000",
      benefits: [
        {
          text: "30 Listings(Max)",
          status: "yes"
        },
        {
          text: "1 Premium Listings",
          status: "yes"
        },
        {
          text: "Unlimited Property Requests",
          status: "yes"
        }
      ]
    },
    {
      tier: "Silver",
      price: "5000",
      benefits: [
        {
          text: "60 Listings(Max)",
          status: "yes"
        },
        {
          text: "5 Premium Listing",
          status: "yes"
        },
        {
          text: "Unlimited Property Requests",
          status: "yes"
        }
      ]
    },
    {
      tier: "Gold",
      price: "10000",
      benefits: [
        {
          text: "180 Listings(Max)",
          status: "yes"
        },
        {
          text: "20 Premium Listings",
          status: "yes"
        },
        {
          text: "Unlimited Property Requests",
          status: "yes"
        }
      ]
    }
  ]

  return (
    <div id="admin-page_wrap">
      <Header toggleNav={toggleNav} setToggleNav={setToggleNav} />
      <SideBar toggleNav={toggleNav} />
      <main id="subscription">
        <section className="page-title">
          <h3><Link to="/dashboard">Dashboard</Link> | Subscription Plans</h3>
        </section>
        <div className="payment-form-info">
          <p>Payments into our accounts requires completing of the <Link to="/plans/payment-form">payment notification form</Link>.</p>
        </div>
        <section className="pricing-tier">
          <h3>Pricing Tier</h3>
          <div className="tier-grid">
            {pricing.map((item, i) => 
              <div key={i} className="tier-card">
                <div className="tier-card_title">
                  <h3>{item.tier}</h3>
                  <div className="price">
                    <span>₦</span>
                    <p>{item.price}&nbsp;<span>.00</span></p>
                  </div>
                </div>
                <div className="tier-body">
                  {item.benefits.map((item, i) =>
                    <div key={i} className={`tier-body_item ${item.status}`}>
                      {item.status === "yes" ?
                        <GiCheckMark />
                      :
                        <CgCloseO />
                      }
                      <span>{item.text}</span>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </section>

        <section className="payment-details">
          <div>
            <h3>All bank transfers, cash and cheque payments should be made to...</h3>
            <div className="acct-info">
              <p>Account Name:</p>
              <p>Clazssy Business Venture</p>
              <p>Account No:</p>
              <p>0621581895</p>
              <p>Bank:</p>
              <p>Guaranty Trust Bank</p>
            </div>
          </div>
          <div>
            <h3>Have questions about our subscription plans? Contact Us.</h3>
            <div className="acct-info">
              <p><MdLocalPhone /></p>
              <a href="tel:+2349139007777">+234 913 900 7777</a>
              <p><FaEnvelope /></p>
              <a href="mailto:support@islandluxurypropertylistings.com">support@islandluxurypropertylistings.com</a>
            </div>
          </div>
        </section>

      </main>
    </div>
  )
}

export default Subscription;